// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__tkNS0","body":"DefaultLayout_body__7I0OR","container":"DefaultLayout_container__NgAo7","main":"DefaultLayout_main__IhW25"};